import createAsyncActions from 'shared/redux/helpers/create-async-actions';

const ACTIONS = createAsyncActions('CLIENT.VOD-SETTINGS.UPDATE', ['SUCCESS']);
export const NAMES = ACTIONS.NAMES;
const { SUCCESS } = ACTIONS;

export { SUCCESS };

export default function(data) {
  return function(dispatch) {
    dispatch(SUCCESS({}, { ...data }));
  };
}
